module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common dialog-common-littlemask" style="position: relative;top: -40px;"><div class="mask-little-tit-msg">亲，你已经抽过奖了啦<p class="little-thanks"><a href="http://i.browser.qq.com/" target="_blank" style="color:#e50156;text-decoration: underline;">个人中心</a>&nbsp;还有很多福利</p><p class="little-thanks">凭已有积分可以兑换更多奖品哦</p></div><div class="little-flow-btn ft" style="margin-top: 42px"><button class="close" style="font-size:18px">我知道了</button></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/no.chance.html
// module id = 37
// module chunks = 0